<template>
  <div>
    <v-toolbar
      color="secondary"
      style="z-index: 1;"
      dark
      elevation-10
    >
      <v-toolbar-title>
        {{$t('app.layoutEditor')}}
      </v-toolbar-title>
    </v-toolbar>
    <v-card
      ref="layoutEditorCard"
    >

      <drop class="layout-editor" @drop="onDrop">
        <loading-overlay
          v-if="isLoading"
          :color="'accent'"
          :size="80"
          :width="5"
        ></loading-overlay>

        <component
          v-for="widget in widgets"
          :key="widget.id"
          :is="widget.component"
          :id="widget.id"
          :ref="`widget${widget.id}`"
          :data="draggedWidget"
        ></component>
      </drop>
    </v-card>
  </div>
</template>

<script>
import { Drop } from 'vue-drag-drop';
import GenericWidget from '@/store/modules/widget';
import LoadingOverlay from '@/components/generic/LoadingOverlay.vue';
import AudioWidget from './widgets/AudioWidget.vue';
import ClockWidget from './widgets/ClockWidget.vue';
import ImageWidget from './widgets/ImageWidget.vue';
import PdfWidget from './widgets/PdfWidget.vue';
import TextWidget from './widgets/TextWidget.vue';
import VideoWidget from './widgets/VideoWidget.vue';
import VncWidget from './widgets/VncWidget.vue';
import WebpageWidget from './widgets/WebpageWidget.vue';
import TickerWidget from './widgets/TickerWidget.vue';
import LibraryImageWidget from './widgets/LibraryImageWidget.vue';
import LibraryAudioWidget from './widgets/LibraryAudioWidget.vue';
import LibraryVideoWidget from './widgets/LibraryVideoWidget.vue';
import LibraryWebpageWidget from './widgets/LibraryWebpageWidget.vue';
import LibraryPdfWidget from './widgets/LibraryPdfWidget.vue';
import YoutubeWidget from './widgets/YoutubeWidget.vue';
import TwitterWidget from './widgets/TwitterWidget.vue';
import RssWidget from './widgets/RssWidget.vue';
import FacebookWidget from './widgets/FacebookWidget.vue';
import MagioWidget from './widgets/MagioWidget.vue';

export default {
  components: {
    Drop,
    AudioWidget,
    ClockWidget,
    ImageWidget,
    PdfWidget,
    TextWidget,
    VideoWidget,
    VncWidget,
    WebpageWidget,
    TickerWidget,
    LibraryImageWidget,
    LibraryAudioWidget,
    LibraryVideoWidget,
    LibraryWebpageWidget,
    LibraryPdfWidget,
    YoutubeWidget,
    TwitterWidget,
    RssWidget,
    FacebookWidget,
    MagioWidget,
    LoadingOverlay,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      widgetID: null,
      widgetCounter: 0,
      apiUrl: window.api_url,
    };
  },
  computed: {
    layout: {
      get() {
        return this.$store.getters.getLayout;
      },
    },
    widgets: {
      get() {
        return this.$store.getters.getWidgets;
      },
    },
    draggedWidget: {
      get() {
        return this.$store.getters.getDraggedWidget;
      },
    },
  },
  created() {
    this.$events.$off('set-active-widget-component');
    this.$events.$off('set-widget-preview-state');

    this.$events.$on('set-active-widget-component', (id) => {
      this.$refs[`widget${id}`][0].$refs.widget.enabled = true;

      this.$events.fire('set-active-widget-properties', {
        id,
        component: this.$refs[`widget${id}`][0].component,
      });
    });

    this.$events.$on('set-widget-preview-state', (payload) => {
      this.$refs[`widget${payload.id}`][0].$refs.widget.elmX = payload.x;
      this.$refs[`widget${payload.id}`][0].$refs.widget.elmY = payload.y;
      this.$refs[`widget${payload.id}`][0].$refs.widget.left = payload.x;
      this.$refs[`widget${payload.id}`][0].$refs.widget.top = payload.y;
      this.$refs[`widget${payload.id}`][0].$refs.widget.rotateAngle = payload.angle;
    });
  },
  methods: {
    setWidgetDefaults(widgetID, widgetName, widgetIcon, widgetComponent, widgetX, widgetY) {
      const payload = {
        data: [
          {
            path: '',
            key: 'id',
            value: widgetID,
          },
          {
            path: '',
            key: 'name',
            value: `widget${this.widgetCounter}`,
          },
          {
            path: '',
            key: 'icon',
            value: widgetIcon,
          },
          {
            path: '',
            key: 'component',
            value: widgetComponent,
          },
          {
            path: 'style',
            key: 'x',
            value: widgetX,
          },
          {
            path: 'style',
            key: 'y',
            value: widgetY,
          },
          {
            path: 'data',
            key: 'name',
            value: widgetName,
          },
        ],
      };

      this.$store.dispatch(`widget${widgetID}/UPDATE_WIDGET`, payload);
      this.widgetCounter += 1;
    },
    onDrop(transferData, event) {
      const store = this.$store;
      const widgetID = this.generateRandomID(8);

      /* eslint-disable no-restricted-globals */
      if (
        !(store && store.state && store.state.widgets[name])
        && transferData != null
        && transferData.isWidget
      ) {
        store.registerModule(['widgets', `widget${widgetID}`], GenericWidget);

        this.setWidgetDefaults(
          widgetID,
          this.draggedWidget.name,
          this.draggedWidget.icon,
          this.draggedWidget.component,
          event.offsetX - 100, // default width of element
          event.offsetY - 100,
        );
      }
      /* eslint-enable */
    },
    generateRandomID(length) {
      return Math.round(
        ((36 ** (length + 1)) - (Math.random() * (36 ** length))),
      ).toString(36).slice(1);
    },
  },
};
</script>

<style>
.layout-editor {
  min-height: 50vh;
  background-color: white;
}

.widget {
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.widget-container {
  border: dashed 1px gray;
}
</style>
